import React, { useState } from "react";
import { TableCell, TableRow } from "../../../../design/table";
import { ClientFile } from "@visitproof/types";
import FileActionButtons from "../../../../components/FileActionButtons";
import DeleteParentFileButton from "./DeleteParentFileButton";
import { Switch } from "../../../../design/switch";
import { useParent } from "../../../../contexts/ParentContext";

type File = ClientFile;

interface Props {
  file: File;
  parentId: string;
}

const ParentDetailFileListItem: React.FC<Props> = ({ file, parentId }) => {
  const { updateFileInParent } = useParent();
  const [isVisibleToSupervisor, setIsVisibleToSupervisor] = useState(
    file.isVisibleToSupervisor,
  );

  const handleSwitchChange = async () => {
    try {
      updateFileInParent(parentId, file.id, {
        isVisibleToSupervisor: !file.isVisibleToSupervisor,
      });
    } catch (error) {
      console.error("Error updating file:", error);
      alert("Failed to update file. Please try again later.");
    }
    setIsVisibleToSupervisor(!isVisibleToSupervisor);
  };

  return (
    <TableRow key={file.id} title={`Visit #${file.id}`}>
      <TableCell>{file.name}</TableCell>
      <TableCell>{file.description}</TableCell>
      <TableCell className="text-center">
        <Switch checked={isVisibleToSupervisor} onChange={handleSwitchChange} />
      </TableCell>
      <TableCell className="flex items-end justify-end gap-2">
        <FileActionButtons path={file.path} />
        <DeleteParentFileButton parentId={parentId} file={file} />
      </TableCell>
    </TableRow>
  );
};

export default ParentDetailFileListItem;
